import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

const initialSchemaData = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Green Park',
  image: 'https://www.greenparkkatowice.pl/static/bg-min-13d0f7580a2c141d4f406fe293eea9e7.jpg',
  '@id': '',
  priceRange: '',
  url: 'https://www.greenparkkatowice.pl/',
  description: 'Kompleks biurowy Green Park w Katowicach ul. Murckowska 14-20 ➤ Wynajem powierzchni biurowej ➤ Sprawdź!',
  disambiguatingDescription:
    'Kompleks biurowy Green Park obejmuje 8 budynków o łącznej powierzchni ok 25 000 m². Budynki mają zróżnicowaną wysokość, od 2 do 6 kondygnacji naziemnych. Efektywne i elastyczne rozmieszczenie powierzchni spełnia wymagania zarówno mniejszych, jak i większych najemców. Do użytku przeznaczone jest ponad 770 miejsca parkingowych.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Katowice',
    addressRegion: 'Województwo śląskie',
    postalCode: '40-265',
    streetAddress: 'Murckowska 14',
    addressCountry: 'PL',
    telephone: '+48 22 307 86 55',
    email: 'natalia.karaluch@martleycap.com',
  },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    opens: '08:00',
    closes: '18:00',
  },
  sameAs: ['https://www.greenparkkatowice.pl/'],
}

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Green Park',
  alternateName: 'Green Park Katowice - Powierzchnia do wynajęcia',
  url: 'https://www.mazoviaplaza.pl/',
  logo: 'https://www.greenparkkatowice.pl/static/bg-min-13d0f7580a2c141d4f406fe293eea9e7.jpg',
  sameAs: 'https://uk.linkedin.com/company/martley-capital-group/',
}

const SEO = ({ title, description, image, pathname, article }) => (
  <StaticQuery
    query={query}
    render={({
      site: {
        siteMetadata: { defaultTitle, titleTemplate, defaultDescription, siteUrl, defaultImage },
      },
    }) => {
      const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: `${siteUrl}${image || defaultImage}`,
        url: `${siteUrl}${pathname || '/'}`,
      }

      return (
        <>
          <Helmet title={seo.title} titleTemplate={titleTemplate}>
            <html lang="pl" />
            <title>{seo.title}</title>
            <meta name="theme-color" content="#000"></meta>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            {seo.url && <meta property="og:url" content={seo.url} />}
            {(article ? true : null) && <meta property="og:type" content="article" />}
            {seo.title && <meta property="og:title" content={seo.title} />}
            {seo.description && <meta property="og:description" content={seo.description} />}
            {seo.image && <meta property="og:image" content={seo.image} />}
            <meta name="twitter:card" content="summary_large_image" />
            {seo.title && <meta name="twitter:title" content={seo.title} />}
            {seo.description && <meta name="twitter:description" content={seo.description} />}
            {seo.image && <meta name="twitter:image" content={seo.image} />}
            <script type="application/ld+json">{JSON.stringify(initialSchemaData)}</script>
            <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
          </Helmet>
        </>
      )
    }}
  />
)
export default SEO
SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  pathname: PropTypes.string,
  article: PropTypes.bool,
}
SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  pathname: null,
  article: false,
}
const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
      }
    }
  }
`
